import * as angular from "angular";
import {IController, IPromise, IQService, IWindowService} from "angular";
import * as _ from "lodash";
import {DataSet} from "vis-data";
import {PlanningAlertsService} from "../../services/planning-alerts.service";
import {PlanningCommonService} from "../../services/planning-coomon-service.service";
import {PlanningDialogService} from "../../services/planning-dialogs-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {TaskModel} from "../../../tasks/models/task.model";
import {transferArrayItem} from "@angular/cdk/drag-drop";
import { Tooltip } from 'bootstrap'
import {BRINGOZ_ID_GENERATOR_ATTRIBUTE_NAME} from "../../../commons/angular/constants/commons";
import {ResizeService} from "../../../commons/services/resize-service.service";
import {escapeHtml} from "../../../commons/utils/html-escape.util";

export class PlanningRoutesTimelineCtrl implements IController {
  from: any;
  to: any;
  allRoutes: any;
  jobs: any;
  depotsMap: any;
  mainRoutes: any;
  routes: any;
  queryString: any;
  draftAnalysis: any;
  draft: any;
  selectedItemId: any;
  selectedJobIds: any;
  canEdit: any;
  displayPrice: any;
  hiddenRouteIds: any;
  hideLockedRoutes?: boolean;
  inspectedStopIds: any;
  isGroupedRoutes: any;
  visibleResourceAllocationSkills: any;
  isValidateRouteVehicles: boolean;
  offset: any;
  limit: any;
  doFit: any;
  onFit: Function;
  onAddStopsToRoute: Function;
  onToggleRoute: Function;
  onRouteInfoClick: Function;
  onToggleHiddenRoutes: Function;
  onRoutesChange: Function;
  onLockRouteChange: Function;
  onInspectedStopIdsChange: Function;
  onZoomActivity: Function;
  onActivitySelection: Function;
  onActivityHover: Function;
  onActivityRightClick: Function;
  onMoveItem: Function;
  onRecalcRoute: Function;
  onDeleteRoute: Function;
  onDispatchRoute: Function;
  onChangeRouteResource: Function;
  onToggleHideLockedRoutes: Function;
  onQueryChange: Function;
  onFiltersChange: Function;
  onPaginationBrowse: Function;
  onPaginationChange: Function;

  public timeline: any;
  public maxPagesToDisplay: number = 3;

  private readonly vis: any;
  private dateAndTimeConfig: any;
  private timeFormat: any;
  private longDateFormat: string;
  private shortDateFormat: string;
  private options: any = {
    min: undefined,
    max: undefined,
    stack: undefined
  };
  private SITE_VOLUME_UNIT: string;
  private SITE_WEIGHT_UNIT: string;
  private container: any;
  private groupsDataSet: any
  private itemsDataSet: any;
  private tableHeaderDivRef: any;
  private movingItem: any;
  private $infinitySymbol: string;
  private actionsByStatus: any;

  /////////////////////////// ICONS ///////////////////////////
  private iconsUrl: any;
  private $weightIcon: any;
  private $volumeIcon: any;
  private $palletsIcon: any;
  private $packageIcon: any;
  private $spotsIcon: any;
  private $accountIcon: any;
  private $addressIcon: any;
  private $originalTimeWindowIcon: any;
  private $timeWindowIcon: any;
  private $barcodeIcon: any;
  private $serviceTimeIcon: any;
  private $relationIcon: any;
  private $infoIcon: any;
  private $skillsIcon: any;
  private $depotIcon: any;
  private $locationIcon: any;
  private $eyeIcon: any;
  private $linkIcon: any;
  private $errorIcon: any;
  private $menuIcon: any;
  private isFirstFit: boolean = true;
  private $lockIcon: any;
  private $tripIcon: any;
  public jobsMap: any;
  public selectedActivities: any[];
  private tooltipRefs: Tooltip[] = [];

  // Single delegated click handler for all group-row actions, attached once on
  // `this.container` after the timeline is created. Replaces 6 per-cell
  // `addEventListener` calls inside `groupTemplate` / cell helpers. Per-group
  // context (e.g. `locked`, `relatedRoutes`) is re-fetched from `groupsDataSet`
  // / `this.allRoutes` on click — fresher than the previous closure capture.
  private readonly _onContainerClick = (event: Event) => {
    const target = event.target as Element | null;
    if (!target) return;
    const actionEl = target.closest('[data-bz-action]') as HTMLElement | null;
    if (!actionEl) return;
    const action = actionEl.dataset.bzAction;
    const id = actionEl.dataset.bzId;
    if (!action || !id) return;

    // `route-action-panel` did not originally wrap in `_onClicked()`; preserve
    // the synchronous shape (the action panel itself is async).
    if (action === 'route-action-panel') {
      if (!this.canEdit) return;
      const route: any = _.find(this.allRoutes, (r: any) => r.id === id);
      if (!route || route.locked) return;
      const actions = ['Reoptimize', 'Delete'];
      if (route.resource?.sequence && !this.draft.settings.ignoreSequence) {
        actions.unshift('Reoptimize & ignore sequence');
      }
      if (route.status !== 'DISPATCHED') {
        actions.unshift('Dispatch');
      }
      this.commonsService.openActionPanel(actions, event, undefined, undefined, 'timeline')
        .then((reason: string) => {
          if (_.isEqual(reason, 'Dispatch')) {
            this.onDispatchRoute({routeId: id});
          } else if (_.isEqual(reason, 'Reoptimize & ignore sequence')) {
            this.onRecalcRoute({routeId: id, ignoreSequence: true});
          } else if (_.isEqual(reason, 'Reoptimize')) {
            this.onRecalcRoute({routeId: id});
          } else if (_.isEqual(reason, 'Delete')) {
            this.onDeleteRoute({routeId: id});
          }
        })
        .catch((reason: any) => {
          this.$log.info('Action Panel Closed', reason);
        });
      return;
    }

    this._onClicked().then(() => {
      if (action === 'toggle-route') {
        const currentlyEnabled = !_.includes(this.hiddenRouteIds, id);
        this.onToggleRoute({id: id, isEnabled: !currentlyEnabled});
      } else if (action === 'route-info') {
        this.onRouteInfoClick({id: id});
      } else if (action === 'lock-route') {
        const group: any = this.groupsDataSet ? this.groupsDataSet.get(id) : null;
        if (group) {
          this.onLockRouteChange({id: id, locked: !group.locked});
        }
      } else if (action === 'change-route-resource') {
        this.onChangeRouteResource({routeId: id, event: event});
      } else if (action === 'combine-related-routes') {
        const relatedIdsAttr = actionEl.dataset.bzRelatedIds || '';
        const uiqRelatedRoutes = _.uniq(relatedIdsAttr.split(',').filter(Boolean));
        const routeIds = [id].concat(uiqRelatedRoutes);
        const routes = _.filter(this.allRoutes, (r: any) => _.includes(routeIds, r.id));
        this.onRoutesChange({routes: routes});
      }
    });
  };

  constructor(private $window: IWindowService, private $timeout, private $q: IQService, private confirmDialogService: ConfirmDialogService, private commonsDialogService: CommonsDialogService,
              private splitService, private planningCommonService: PlanningCommonService, private $filter, private leanPlanningConstants, private commonsService: CommonsService,
              private planningAlertsService: PlanningAlertsService, private $log, private moment, private planningDialogService: PlanningDialogService, private resizeService: ResizeService) {
    this.vis = require('vis-timeline');
    this.$infinitySymbol = '&#8734;';

    /////////////////////////// ICONS ///////////////////////////
    this.iconsUrl = {
      account: 'assets/images/icons/v2/account.svg',
      address: 'assets/images/icons/v2/location-pin.svg',
      weight: 'assets/images/icons/v2/weight.svg',
      volume: 'assets/images/icons/v2/volume.svg',
      pallets: 'assets/images/icons/v2/pallets.svg',
      originalTimeWindow: 'assets/images/icons/v2/calendar-outline.svg',
      timeWindow: 'assets/images/icons/v2/time-window-outline.svg',
      barcode: 'assets/images/icons/v2/barcode.svg',
      serviceTime: 'assets/images/icons/v2/timer-outline.svg',
      relation: 'assets/images/icons/v2/relation.svg',
      packageItem: 'assets/images/icons/v2/package-outline.svg',
      spot: 'assets/images/icons/v2/spot.svg',
      info: 'assets/images/icons/v2/info-outline.svg',
      skills: 'assets/images/icons/v2/skill.svg',
      depot: 'assets/images/icons/v2/depot.svg',
      eye: 'assets/images/icons/v2/show.svg',
      eyeOn: 'assets/images/icons/v2/eye-on.svg',
      eyeOff: 'assets/images/icons/v2/eye-off.svg',
      location: 'assets/images/icons/v2/location-pin-outline.svg',
      link: 'assets/images/icons/v2/linked.svg',
      error: 'assets/images/icons/v2/error-outline.svg',
      menu: 'assets/images/icons/v2/menu.svg',
      locked: 'assets/images/icons/v2/lock.svg',
      unlocked: 'assets/images/icons/v2/lock-open-outline.svg',
      trip: 'assets/images/icons/v2/route.svg',
      loader: 'assets/images/icons/v2/loader.svg'
    }
    this.$accountIcon = document.createElement('IMG');
    this.$accountIcon.setAttribute("src", this.iconsUrl.account);
    this.$accountIcon.classList.add('icon', 'bringoz-icon-small');

    this.$addressIcon = document.createElement('IMG');
    this.$addressIcon.setAttribute("src", this.iconsUrl.address);
    this.$addressIcon.classList.add('icon', 'bringoz-icon-small');

    this.$weightIcon = document.createElement('IMG');
    this.$weightIcon.setAttribute("src", this.iconsUrl.weight);
    this.$weightIcon.classList.add('icon');

    this.$volumeIcon = document.createElement('IMG');
    this.$volumeIcon.setAttribute("src", this.iconsUrl.volume);
    this.$volumeIcon.classList.add('icon');

    this.$palletsIcon = document.createElement('IMG');
    this.$palletsIcon.setAttribute("src", this.iconsUrl.pallets);
    this.$palletsIcon.classList.add('icon');

    this.$originalTimeWindowIcon = document.createElement('IMG');
    this.$originalTimeWindowIcon.setAttribute("src", this.iconsUrl.originalTimeWindow);
    this.$originalTimeWindowIcon.classList.add('icon', 'bringoz-icon-small');

    this.$timeWindowIcon = document.createElement('IMG');
    this.$timeWindowIcon.setAttribute("src", this.iconsUrl.timeWindow);
    this.$timeWindowIcon.classList.add('icon', 'bringoz-icon-small');

    this.$tripIcon = document.createElement('IMG');
    this.$tripIcon.setAttribute("src", this.iconsUrl.trip);
    this.$tripIcon.classList.add('icon', 'bringoz-icon-small');

    this.$barcodeIcon = document.createElement('IMG');
    this.$barcodeIcon.setAttribute("src", this.iconsUrl.barcode);
    this.$barcodeIcon.classList.add('icon', 'bringoz-icon-small');

    this.$serviceTimeIcon;
    this.$serviceTimeIcon = document.createElement('IMG');
    this.$serviceTimeIcon.setAttribute("src", this.iconsUrl.serviceTime);
    this.$serviceTimeIcon.classList.add('icon', 'bringoz-icon-small');

    this.$relationIcon = document.createElement('IMG');
    this.$relationIcon.setAttribute("src", this.iconsUrl.relation);
    this.$relationIcon.classList.add('icon', 'bringoz-icon-small');

    this.$packageIcon = document.createElement('IMG');
    this.$packageIcon.setAttribute("src", this.iconsUrl.packageItem);
    this.$packageIcon.classList.add('icon');

    this.$spotsIcon = document.createElement('IMG');
    this.$spotsIcon.setAttribute("src", this.iconsUrl.spot);
    this.$spotsIcon.classList.add('icon');

    this.$infoIcon = document.createElement('IMG');
    this.$infoIcon.setAttribute("src", this.iconsUrl.info);
    this.$infoIcon.classList.add('icon', 'bringoz-icon-small');

    this.$skillsIcon = document.createElement('IMG');
    this.$skillsIcon.setAttribute("src", this.iconsUrl.skills);
    this.$skillsIcon.classList.add('icon', 'bringoz-icon-small');

    this.$depotIcon = document.createElement('IMG');
    this.$depotIcon.setAttribute("src", this.iconsUrl.depot);
    this.$depotIcon.classList.add('icon', 'bringoz-icon-small');

    this.$eyeIcon = document.createElement('IMG');
    this.$eyeIcon.setAttribute("src", this.iconsUrl.eyeOn);
    this.$eyeIcon.classList.add('icon', 'bringoz-icon');

    this.$locationIcon = document.createElement('IMG');
    this.$locationIcon.setAttribute("src", this.iconsUrl.location);
    this.$locationIcon.classList.add('icon', 'bringoz-icon');

    this.$linkIcon = document.createElement('IMG');
    this.$linkIcon.setAttribute("src", this.iconsUrl.link);
    this.$linkIcon.classList.add('icon', 'bringoz-icon');

    this.$errorIcon = document.createElement('IMG');
    this.$errorIcon.setAttribute("src", this.iconsUrl.error);
    this.$errorIcon.classList.add('icon', 'bringoz-icon');

    this.$menuIcon = document.createElement('IMG');
    this.$menuIcon.setAttribute("src", this.iconsUrl.menu);
    this.$menuIcon.classList.add('icon', 'bringoz-icon');

    this.$lockIcon = document.createElement('IMG');
    this.$lockIcon.setAttribute("src", this.iconsUrl.unlocked);
    this.$lockIcon.classList.add('icon', 'bringoz-icon');
  }

  $onInit() {

    this.dateAndTimeConfig = this.splitService.getDateAndTimeConfig();
    this.timeFormat = this.dateAndTimeConfig.time;
    this.shortDateFormat = this.dateAndTimeConfig.date;
    this.longDateFormat = this.dateAndTimeConfig.long;
    this.SITE_WEIGHT_UNIT = this.$filter('translate')(this.splitService.getWeightUnit());
    this.SITE_VOLUME_UNIT = this.$filter('translate')(this.splitService.getVolumeUnit());
    this.container = document.getElementById('timeline');
    this.groupsDataSet = new DataSet();
    this.itemsDataSet = new DataSet();
    this.jobsMap = _.keyBy(this.jobs, (j) => {
      return j.id
    })

    const options = {
      // option groupOrder can be a property name or a sort function
      // the sort function must compare two groups and return a value
      //     > 0 when a > b
      //     < 0 when a < b
      //       0 when a == b
      groupOrder: (a, b) => {
        return a.order - b.order;
      },
      groupOrderSwap: (groupDragged, groupToSwap) => {
        const value = groupDragged.order;
        groupDragged.order = groupToSwap.order;
        groupToSwap.order = value;
      },
      groupTemplate: (group) => {

        if (!group) {
          return null;
        }

        const container = document.createElement('div');
        container.classList.add("table-container");

        // var columns = [
        //   {key: 'resource', values: [group.resourceName, group.status, group.relatedRoutes]},
        //   {key: 'agent', values: [group.agentName, group.agentSkills]},
        //   {key: 'vehicle', values: [group.vehicle]},
        //   {key: 'value', values: [group.value]},
        //   {key: 'cost', values: [group.cost]},
        //   {key: 'distance', values: [group.distance]},
        //   {key: 'stops', values: [group.stops]},
        //   {
        //     key: 'capacity', values: [
        //       {v: group.weight, max: group.maxWeight, icon: $weightIcon, unit: SITE_WEIGHT_UNIT},
        //       {v: group.volume, max: group.maxVolume, icon: $volumeIcon, unit: SITE_VOLUME_UNIT},
        //       {v: group.packagesCount, max: group.maxPackagesCount, icon: $packageIcon},
        //       {v: group.spots, max: group.maxSpots, icon: $spotsIcon}
        //     ]
        //   },
        //   {key: 'alerts', values: [group.alerts]},
        //   {key: 'timeWindow', values: [group.timeWindow, group.duration]},
        //   {key: 'startEnd', values: [group.startDepot, group.endDepot]}
        // ];

        let columns = [
          {key: 'resource', values: [group.resourceName, group.status, group.relatedRoutes]},
          {key: 'income', values: [group.totalIncome]},
          {
            key: 'capacity', values: [
              {v: group.weight, max: group.maxWeight, icon: this.$weightIcon, unit: this.SITE_WEIGHT_UNIT, tooltip: this.$filter('translate')('Weight')},
              {v: group.volume, max: group.maxVolume, icon: this.$volumeIcon, unit: this.SITE_VOLUME_UNIT, tooltip: this.$filter('translate')('Volume')},
              {v: group.packagesCount, max: group.maxPackagesCount, icon: this.$packageIcon, tooltip: this.$filter('translate')('Packages')},
              {v: group.spots, max: group.maxSpots, icon: this.$spotsIcon, tooltip: this.$filter('translate')('Spots')},
              {v: group.pallets, max: group.maxPallets, icon: this.$palletsIcon, tooltip: this.$filter('translate')('Pallets')},
            ]
          }
        ];

        if (!this.displayPrice) {
          columns = _.filter(columns, (c) => {
            return c.key !== 'value' && c.key !== 'cost';
          })
        }

        const actionsContainer = document.createElement('div');
        actionsContainer.classList.add("table-item", 'action-item-container', 'padding-0');

        const actionsButton = this.$menuIcon.cloneNode(true);
        actionsButton.classList.add("margin-0", "route-actions");
        (actionsButton as HTMLElement).setAttribute(BRINGOZ_ID_GENERATOR_ATTRIBUTE_NAME, "menu-button-timeline");

        const routeColorDiv = document.createElement('div');
        routeColorDiv.classList.add("route-color");
        routeColorDiv.style.setProperty('background-color', group.color);

        const eyeButton = this._createEyeButton(group.id, !_.includes(this.hiddenRouteIds, group.id));
        eyeButton.setAttribute(BRINGOZ_ID_GENERATOR_ATTRIBUTE_NAME, "eye-icon-route-timeline");

        const infoButton = this._createInfoButton(group.id);
        infoButton.setAttribute(BRINGOZ_ID_GENERATOR_ATTRIBUTE_NAME, "show-route-timeline");

        var iconsDiv = document.createElement('div');
        iconsDiv.classList.add("group-action-div");
        iconsDiv.appendChild(eyeButton);
        // iconsDiv.appendChild(testButton);
        iconsDiv.appendChild(infoButton);

        actionsContainer.appendChild(actionsButton);
        actionsContainer.appendChild(routeColorDiv);
        actionsContainer.appendChild(iconsDiv);

        const blockDiv = document.createElement('div');
        const blockButton = this._createBlockButton(group.id, group.locked, group.running);

        blockDiv.appendChild(blockButton);
        actionsContainer.appendChild(blockDiv);

        container.insertAdjacentElement('beforeend', actionsContainer);

        if (group.id) {
          actionsButton.dataset.bzAction = 'route-action-panel';
          actionsButton.dataset.bzId = String(group.id);
        }

        _.forEach(columns, (c) => {
          const element = document.createElement('div');
          const elementColumns = [];

          element.classList.add("table-item", "br-caption-2", c.key);
          if (c.key === 'capacity') {
            element.classList.add("flex-row");
            _.times(2, (num) => {
              const column = document.createElement('div');
              if (num === 0) {
                column.style.width = '130px';
                column.classList.add('text-ellipsis');
              }
              column.classList.add('flex-column');
              elementColumns.push(column);
            })
          }
          _.forEach(c.values, (value, index) => {
            let valueElement;
            if (c.key === 'capacity') {
              valueElement = document.createElement('div');
              const span = document.createElement('span');
              span.classList.add("br-body-1", "font-weight-400", c.key);

              valueElement.classList.add("item-value", c.key);

              span.innerHTML = (value.v > 1000 ? (value.v / 1000).toFixed(1).replace(/\.0$/, '') + 'K' : value.v) + '/' +
                (value.max > 1000 ? (value.max / 1000).toFixed(1).replace(/\.0$/, '') + 'K' : value.max) + ' ' + (value.unit || '');

              const iconRef = angular.copy(value.icon);
              iconRef.setAttribute("data-bs-toggle", "tooltip");
              iconRef.setAttribute("data-bs-placement", "top");
              iconRef.setAttribute("data-bs-custom-class", "basic-tooltip");
              iconRef.setAttribute("data-bs-title", value.tooltip);
              this.tooltipRefs.push(new Tooltip(iconRef));

              const loadPercentage = value.v / value.max;
              if (Number.isNaN(loadPercentage)) {
                iconRef.classList.add("margin-left-0", "unlimited");
              } else if (loadPercentage < 0.7) {
                iconRef.classList.add("margin-left-0", "available");
              } else if (loadPercentage > 1) {
                iconRef.classList.add("margin-left-0", "overloaded");
              } else {
                iconRef.classList.add("margin-left-0", "warning");
              }

              valueElement.appendChild(iconRef);
              valueElement.appendChild(span);
              if (index < 2) {
                elementColumns[0].appendChild(valueElement);
              } else {
                elementColumns[1].appendChild(valueElement);
              }
            } else if (c.key === 'resource') {
              if (index === 0) {
                let routeName = this.routes.find(route => route.id === group.id).name ?? '';
                let contentText = (value + " " + routeName).trim();

                valueElement = document.createElement('span');
                valueElement.setAttribute("id", "change-resource-btn");
                valueElement.setAttribute(BRINGOZ_ID_GENERATOR_ATTRIBUTE_NAME, "dropdown-route-timeline");
                valueElement.setAttribute("data-bs-toggle", "tooltip");
                valueElement.setAttribute("data-bs-placement", "top");
                valueElement.setAttribute("data-bs-custom-class", "basic-tooltip");
                valueElement.setAttribute("data-bs-title", contentText);
                valueElement.classList.add("item-value", "br-body-1", "font-weight-400", "text-ellipsis", c.key);
                valueElement.textContent = contentText;
                this.tooltipRefs.push(new Tooltip(valueElement));
                if (group.id) {
                  valueElement.dataset.bzAction = 'change-route-resource';
                  valueElement.dataset.bzId = String(group.id);
                }
              }
              if (index === 1) {
                valueElement = document.createElement('span');
                valueElement.classList.add("item-value", "br-body-1", "font-weight-400", "route-status", group.status);
                valueElement.textContent = value ? this.$filter('translate')('STATUS_TAG.' + value) : '';
              }
              if (index === 2) {

                let relationsGroupSection = undefined

                if (_.get(value, 'length')) {
                  const linkedRoutesBtn = this.$linkIcon.cloneNode(true);
                  linkedRoutesBtn.classList.add("route-relation-button");

                  linkedRoutesBtn.appendChild(this._getRelatedRoutesIndicationDiv(value));

                  relationsGroupSection = document.createElement('div');
                  relationsGroupSection.classList.add("route-relation-button-container");

                  relationsGroupSection.appendChild(linkedRoutesBtn);

                  if (group && group.id) {
                    linkedRoutesBtn.dataset.bzAction = 'combine-related-routes';
                    linkedRoutesBtn.dataset.bzId = String(group.id);
                    linkedRoutesBtn.dataset.bzRelatedIds = (group.relatedRoutes || []).join(',');
                  }
                }

                if (relationsGroupSection) {
                  valueElement = relationsGroupSection;
                }
              }
            } else if (c.key === 'income') {
              if (index === 0) {
                const incomeClass = (!!group.minimumIncome && (group.totalIncome < group.minimumIncome)) ? 'low' :
                  ((!!group.maximumIncome && (group.totalIncome > group.maximumIncome)) ? 'high' : 'mid');

                valueElement = document.createElement('span');
                valueElement.classList.add("item-value", "br-body-1", "font-weight-400", c.key, incomeClass);
                valueElement.textContent = this.$filter('bringozPrice')(group.totalIncome);
              }
            } else if (c.key === 'alerts') {
              valueElement = document.createElement('div');
              valueElement.classList.add("item-value", "br-body-1", c.key);

              const warningCount = document.createElement('span');
              warningCount.textContent = value.length || '---';

              if (value.length) {
                warningCount.classList.add("warn");
              }

              const tooltip = document.createElement('div');
              tooltip.classList.add("table-tooltip");
              const tooltipContainer = document.createElement('div');
              tooltipContainer.classList.add("tooltip-container");

              const warningList = this._getWarningDetails(value);
              _.forEach(warningList, (w) => {
                const infoRow = document.createElement('div');
                infoRow.classList.add("info-row");

                const icon = this.$errorIcon.cloneNode(true);
                icon.classList.add("warn");

                const warningDetails = document.createElement('span');
                warningDetails.textContent = w;

                infoRow.appendChild(icon);
                infoRow.appendChild(warningDetails);
                tooltipContainer.appendChild(infoRow);
              });

              tooltip.appendChild(tooltipContainer);

              valueElement.appendChild(warningCount);

              if (value.length) {
                valueElement.appendChild(tooltip);
              }
            } else if (c.key === 'agent') {
              if (index === 0) {
                valueElement = document.createElement('span');
                valueElement.classList.add("item-value", "br-body-1", "font-weight-400", c.key);
                valueElement.textContent = value;
              }
              if (index === 1) {
                valueElement = document.createElement('div');
                const skillsContainer = document.createElement('div');
                skillsContainer.classList.add('skill-tags-container');
                _.forEach(value, function (s, i) {

                  const skill = document.createElement('div');
                  skill.classList.add('skill-tag', 'skill-tag-margin');

                  const skillText = document.createElement('span')
                  skillText.classList.add("item-value", "br-body-1", "font-weight-400", c.key);
                  skillText.textContent = s;
                  skill.appendChild(skillText);
                  skillsContainer.appendChild(skill);
                })
                valueElement.appendChild(skillsContainer);
              }
            } else {
              valueElement = document.createElement('span');
              valueElement.classList.add("item-value", "br-body-1", "font-weight-400", c.key);
              valueElement.textContent = value;
            }
            if (elementColumns.length) {
              _.forEach(elementColumns, function (c) {
                element.appendChild(c);
              })
            } else if (valueElement) {
              element.insertAdjacentElement('beforeend', valueElement);
            }
          });
          container.insertAdjacentElement('beforeend', element);
        });

        return container;
      },
      onMoving: (item, callback) => {
        if (item.stopId || item.stopIds) {
          callback(item); // updating the item
        } else {
          callback(null); // cancel updating the item
        }
      },
      onMove: (item, callback) => {
        const fromRouteId = item.routeId;
        const toRouteId = item.group;
        const isBetweenRoutes = fromRouteId !== toRouteId;
        const routeToRef = isBetweenRoutes ? _.find(this.routes, ['id', item.group]) : undefined

        callback(item);
        const canMove = this._canItemMove(item);

        if (!!routeToRef?.locked) {
          this.planningAlertsService.routeIsLocked();
          callback(null);
          return;
        }

        if (this._getIsRouteRunning(routeToRef)) {
          this.planningAlertsService.routeIsLocked();
          callback(null);
          return;
        }

        if (!canMove) {
          callback(null);
          return;
        }

        const groupsMap = this.timeline.components[3].groups;
        const isGroupActivity = _.isEqual(item.activityType, 'GROUP');

        if (isGroupActivity && !!isBetweenRoutes) {
          let allowSkillsMismatch = false;

          this.planningDialogService.selectActivity(item.ref.stopActivities)
            .then((selectedActivities) => {
              return this._confirmSkillMismatch(_.map(selectedActivities, 'jobId'), routeToRef)
                .then((allow) => {
                  allowSkillsMismatch = allow;
                  return selectedActivities;
                });
            })
            .then((selectedActivities) => {

              let itemJobs = [];

              if (!!this.jobs?.length) {
                itemJobs = _.map(selectedActivities, (activity) => {
                  return this.jobsMap[activity.jobId];
                })
              }

              let isValidateRouteVehicle = false;
              for (let job of itemJobs) {
                const jobVehicleTypes = _.map(job.allowedVehicleReferences, 'type');
                if (this.isValidateRouteVehicles && !!routeToRef.resource?.vehicleClass &&
                  jobVehicleTypes?.length && !jobVehicleTypes.includes(routeToRef.resource?.vehicleClass)) {
                  isValidateRouteVehicle = true;
                  break;
                }
              }

              if (isValidateRouteVehicle) {
                const confirmDialogDescription = itemJobs.length > 1 ? "Services vehicle types do not match route resource vehicle type. Are you sure you want to proceed?" :
                  "Service vehicle types do not match route resource vehicle type. Are you sure you want to proceed?"
                this.confirmDialogService.confirm("Confirm",
                  confirmDialogDescription)
                  .then(() => {
                    if (item.ref.stopActivities.length === selectedActivities.length) {
                      this.onMoveItem(
                        {
                          jobIds: item.jobIds,
                          fromRouteId: fromRouteId,
                          toRouteId: toRouteId,
                          fromOrderedIds: _getStopsOrderIds(groupsMap[fromRouteId].orderedItems.byStart),
                          toOrderedIds: isBetweenRoutes ? _getStopsOrderIds(groupsMap[toRouteId].orderedItems.byStart) : undefined,
                          allowSkillsMismatch: allowSkillsMismatch
                        }
                      );
                    } else {
                      const originalRoute = _.find(this.routes, (r) => {
                        return r.id === fromRouteId;
                      })
                      const fromOrderIds = _.chain(originalRoute.activities)
                        .filter((a) => {
                          return _.isEqual(a.type, 'STOP') || _.isEqual(a.type, 'GROUP')
                        })
                        .map((filteredActivity) => {
                          const stopIds = filteredActivity.stopId ? [filteredActivity.stopId] : angular.copy(filteredActivity.stopIds);

                          _.forEach(_.map(selectedActivities, 'stopId'), (stopIdToRemove) => {
                            const removeIndex = _.findIndex(stopIds, (id) => {
                              return id === stopIdToRemove;
                            })
                            if (removeIndex > -1) {
                              stopIds.splice(removeIndex, 1);
                            }
                          });
                          return stopIds;
                        })
                        .flatten()
                        .value();

                      const toOrderedIds = _.chain(_getStopsOrderIds(groupsMap[toRouteId].orderedItems.byStart))
                        .map((stopId) => {
                          return _.includes(item.stopIds, stopId) ? _.map(selectedActivities, 'stopId') : stopId;
                        })
                        .flatten()
                        .uniq()
                        .value();

                      this.onMoveItem(
                        {
                          jobIds: _.map(selectedActivities, 'jobId'),
                          fromRouteId: fromRouteId,
                          toRouteId: toRouteId,
                          fromOrderedIds: fromOrderIds,
                          toOrderedIds: toOrderedIds,
                          allowSkillsMismatch: allowSkillsMismatch
                        }
                      );
                    }
                  })
                  .catch(() => {
                    callback(null);
                    return;
                  });
              } else {
                if (item.ref.stopActivities.length === selectedActivities.length) {
                  this.onMoveItem(
                    {
                      jobIds: item.jobIds,
                      fromRouteId: fromRouteId,
                      toRouteId: toRouteId,
                      fromOrderedIds: _getStopsOrderIds(groupsMap[fromRouteId].orderedItems.byStart),
                      toOrderedIds: isBetweenRoutes ? _getStopsOrderIds(groupsMap[toRouteId].orderedItems.byStart) : undefined,
                      allowSkillsMismatch: allowSkillsMismatch
                    }
                  );
                } else {
                  const originalRoute = _.find(this.routes, (r) => {
                    return r.id === fromRouteId;
                  })
                  const fromOrderIds = _.chain(originalRoute.activities)
                    .filter((a) => {
                      return _.isEqual(a.type, 'STOP') || _.isEqual(a.type, 'GROUP')
                    })
                    .map((filteredActivity) => {
                      const stopIds = filteredActivity.stopId ? [filteredActivity.stopId] : angular.copy(filteredActivity.stopIds);

                      _.forEach(_.map(selectedActivities, 'stopId'), (stopIdToRemove) => {
                        const removeIndex = _.findIndex(stopIds, (id) => {
                          return id === stopIdToRemove;
                        })
                        if (removeIndex > -1) {
                          stopIds.splice(removeIndex, 1);
                        }
                      });
                      return stopIds;
                    })
                    .flatten()
                    .value();

                  const toOrderedIds = _.chain(_getStopsOrderIds(groupsMap[toRouteId].orderedItems.byStart))
                    .map((stopId) => {
                      return _.includes(item.stopIds, stopId) ? _.map(selectedActivities, 'stopId') : stopId;
                    })
                    .flatten()
                    .uniq()
                    .value();

                  this.onMoveItem(
                    {
                      jobIds: _.map(selectedActivities, 'jobId'),
                      fromRouteId: fromRouteId,
                      toRouteId: toRouteId,
                      fromOrderedIds: fromOrderIds,
                      toOrderedIds: toOrderedIds,
                      allowSkillsMismatch: allowSkillsMismatch
                    }
                  );
                }
              }


            })
            .catch(() => {
              callback(null);
            })
            .finally(() => {
              this.movingItem = undefined;
            })
        } else {
          this._confirmSkillMismatch(item.jobIds, routeToRef)
            .then((allowSkillsMismatch) => {
              this.onMoveItem(
                {
                  jobIds: item.jobIds,
                  fromRouteId: fromRouteId,
                  toRouteId: toRouteId,
                  fromOrderedIds: _getStopsOrderIds(groupsMap[fromRouteId].orderedItems.byStart),
                  toOrderedIds: isBetweenRoutes ? _getStopsOrderIds(groupsMap[toRouteId].orderedItems.byStart) : undefined,
                  allowSkillsMismatch: allowSkillsMismatch
                }
              );
            })
            .catch(() => {
              callback(null);
            })
            .finally(() => {
              this.movingItem = undefined;
            });
        }

        function _getStopsOrderIds(items) {
          return _.chain(items)
            .filter((item) => {
              return _.isEqual(item.data.activityType, 'STOP') || _.isEqual(item.data.activityType, 'GROUP');
            })
            .map((filteredItem) => {
              return filteredItem.data.stopId || filteredItem.data.stopIds;
            })
            .flatten()
            .value();
        }
      },
      snap: (date, scale, step) => {
        const minute = 60 * 1000;
        return Math.round(date / minute) * minute;
      },
      onAdd: (data, callback) => {

        if (!data.items || !data.items.length) {
          callback(null);
          return;
        }

        const route = _.find(this.routes, (r) => {
          return r.id === data.group;
        });

        if (!!route.locked) {
          this.planningAlertsService.routeIsLocked();
          callback(null);
          return;
        }

        if (this._getIsRouteRunning(route)) {
          this.planningAlertsService.routeIsLocked();
          callback(null);
          return;
        }

        let index = 0;
        let order = [];
        let stopActivities = _.filter(route.activities, (a) => {
          return _.isEqual(a.type, 'STOP') || _.isEqual(a.type, 'GROUP')
        })

        _.forEach(stopActivities, (a, i) => {
          if (a.eta < data.start.valueOf()) {
            index = i + 1;
          }
          if (_.isEqual(a.type, 'STOP')) {
            order.push(a.stopId);
          }
          if (_.isEqual(a.type, 'GROUP')) {
            order = order.concat(a.stopIds);
          }
        });

        let stopIds = [];
        let jobIds = [];
        _.forEach(data.items, (i) => {
          stopIds = stopIds.concat(i.stopIds);
          jobIds = jobIds.concat(i.jobIds)
        });

        _.forEach(stopIds, (id, i) => {
          order.splice(index + i, 0, id);
        });
        this._confirmSkillMismatch(jobIds, route)
          .then((allowSkillsMismatch) => {
            this.onAddStopsToRoute({routeId: data.group, jobIds: jobIds, order: order, allowSkillsMismatch: allowSkillsMismatch});
          })
          .catch(() => null);
        callback(null);
      },
      orientation: 'top',
      format: {
        minorLabels: {
          minute: this.timeFormat,
          hour: this.timeFormat,
          weekday: this.longDateFormat,
          day: this.shortDateFormat
        }
      },
      // editable: true,
      // selectable: true,
      // multiselect: false,
      editable: {
        add: this.canEdit,                       // add new items by double tapping
        updateTime: this.canEdit,        // drag items horizontally
        updateGroup: this.canEdit,      // drag items from one group to another
        remove: false,                 // delete an item by tapping the delete button top right
        overrideItems: false          // allow these options to override item.editable
      },
      xss: {
        disabled: true,
        // filterOptions: {
        //   whiteList: { p: ['class', 'data-from-template'], div: 'class' },
        // },
      },
      // tooltipOnItemUpdateTime: {
      //   template: function(item) {
      //     // Option to add tooltip when dragging item (useful)
      //     return 'html template for tooltip with <b>item.start</b>: ' + item.start;
      //   }
      // },
      groupEditable: true,
      verticalScroll: true,
      zoomKey: 'ctrlKey',
      width: '100%',
      height: '100%',
      // margin: {
      //     item: 5
      // },
      margin: {
        item: {
          horizontal: -1,
          vertical: 20
        },
        axis: 10
      },
      stack: !this.isGroupedRoutes,
      showTooltips: false,
      tooltip: {
        followMouse: true
      },
      start: this.moment(this.from).subtract(1, 'hour'),
      end: this.moment(this.to).add(1, 'hour'),
      // min: moment(ctrl.from).subtract(1, 'hour'),
      // max: moment(ctrl.to).add(1, 'hour'),
      zoomMin: 1080000 // Zoom In Max 5 Mins
      // zoomMax: 18800000 // Zoom Out Max 1 Hour,
    };
    this.timeline = new this.vis.Timeline(this.container, this.itemsDataSet, this.groupsDataSet, options);

    // Single delegated click handler — replaces per-cell addEventListener calls
    // inside groupTemplate so listener count stays O(1) regardless of vis redraws.
    this.container.addEventListener('click', this._onContainerClick);

    let customDate = this.moment(this.to).toDate();
    this.timeline.addCustomTime(customDate);
    this.timeline.customTimes[0].hammer.off("panstart panmove panend");

    // Check permissions to update roues
    if (_.isUndefined(this.canEdit)) {
      this.canEdit = false;
    }

    // Set Table Header Element
    const topElementRef = this.timeline.body.dom.top;
    topElementRef.style = 'left: 0px';
    this.tableHeaderDivRef = document.createElement("div");
    this.tableHeaderDivRef.classList.add("table-header-container");
    topElementRef.before(this.tableHeaderDivRef);

    if (this.routes?.length) {
      this._addRoutesToTimeline(this.routes);
      this._addActivitiesToTimeline(this.routes);
      this.fitTimeline();
      this.isFirstFit = false;
    }

    this._initTimelineEventListeners();
    this.fitTimeline();
  };

  $onDestroy(): void {
    if (this.container) {
      this.container.removeEventListener('click', this._onContainerClick);
      this.container = null;
    }
    this.tooltipRefs.forEach(tooltip => tooltip.dispose());
    this.tooltipRefs = [];

    if (this.timeline) {
      this.timeline.destroy();
      this.timeline = null;
    }
    if (this.itemsDataSet) {
      this.itemsDataSet.clear();
      this.itemsDataSet = null;
    }
    if (this.groupsDataSet) {
      this.groupsDataSet.clear();
      this.groupsDataSet = null;
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.draftAnalysis && !changes.draftAnalysis.isFirstChange()) {
      // this.groupsDataSet.clear();
      // this.itemsDataSet.clear();
      //
      // this._addRoutesToTimeline(this.routes);
      // this._addActivitiesToTimeline(this.routes);
    }

    if (changes.routes && !changes.routes.isFirstChange()) {
      const currentRoutes = changes.routes.currentValue || [];
      const previousRoutes = changes.routes.previousValue || [];

      // PlanningDraftService.getRoutesChanges(currentRoutes, previousRoutes)

      const routesToAdd: any[] = _.differenceBy(currentRoutes, previousRoutes, 'id');
      const routesToRemove: any[] = _.differenceBy(previousRoutes, currentRoutes, 'id');

      const currentUpdatedRoutes = _.differenceBy(currentRoutes, routesToAdd, 'id');
      const previousUpdatedRoutes = _.differenceBy(previousRoutes, routesToRemove, 'id');

      const currentRoutesToUpdate = _.filter(currentUpdatedRoutes, (currentUpdatedRoute: any) => {
        let previousUpdatedRoute: any = _.find(previousUpdatedRoutes, ['id', currentUpdatedRoute.id]);

        // Check if route was changed
        return (_.get(previousUpdatedRoute, 'activities.length') !== _.get(currentUpdatedRoute, 'activities.length')) ||
          (previousUpdatedRoute.updatedAt < currentUpdatedRoute.updatedAt);
      });

      const previousRoutesToUpdate = _.filter(previousUpdatedRoutes, (previousUpdatedRoute: any) => {
        const currentUpdatedRoute: any = _.find(currentUpdatedRoutes, ['id', previousUpdatedRoute.id]);
        // Check if route was changed
        return (_.get(currentUpdatedRoute, 'activities.length') !== _.get(previousUpdatedRoute, 'activities.length')) ||
          previousUpdatedRoute.updatedAt < currentUpdatedRoute.updatedAt;
      });

      // Remove groups and items
      const activitiesToRemove = _.flatMap(_.concat(routesToRemove, previousRoutesToUpdate), 'activities');
      const activityItemIdsToRemove = _.map(activitiesToRemove, 'id');
      let routesToRemoveBackgroundItems = [];
      let routesToRemoveTripItems = [];
      routesToRemove.forEach(r => {
        r.activities.forEach(a => {
          routesToRemoveBackgroundItems.push(r.id + a.id);

          if (a.tripNumber) {
            routesToRemoveTripItems = _.uniq(routesToRemoveTripItems.concat(r.id + a.tripNumber));
          }
        })
      })
      let previousRoutesToUpdateBackgroundItems = [];
      previousRoutesToUpdate.forEach(r => {
        r.activities.forEach(a => {
          previousRoutesToUpdateBackgroundItems.push(r.id + a.id);
        })
      })
      const backgroundItemIdsToRemove = _.concat(routesToRemoveBackgroundItems, routesToRemoveTripItems, previousRoutesToUpdateBackgroundItems);
      const routeIdsToRemove = _.map(routesToRemove, 'id');


      if (routeIdsToRemove.length) {
        this.groupsDataSet.remove(routeIdsToRemove);
      }

      if (_.concat(activityItemIdsToRemove, backgroundItemIdsToRemove).length) {
        this.itemsDataSet.remove(_.concat(activityItemIdsToRemove, backgroundItemIdsToRemove));
      }

      // Create groups and items
      // var routesToAddAndUpdate = _.concat(routesToAdd, routesToUpdate);
      this.$timeout(() => {
        this._addRoutesToTimeline(routesToAdd);
        this._addActivitiesToTimeline(_.concat(routesToAdd, currentRoutesToUpdate));
      }, 0);
      // var groupsToAdd = _mapRoutesToGroups(routesToAdd, ctrl.draftAnalysis);
      // var activityItemsToAdd = _mapRoutesToActivityItems(_.concat(routesToAdd, currentRoutesToUpdate), ctrl.draftAnalysis);
      // var backgroundItemsToAdd = _mapRoutesToBackgroundItems(_.concat(routesToAdd, currentRoutesToUpdate));
      //
      // groupsDataSet.add(_.sortBy(groupsToAdd, ['resourceName', 'eta']));
      // itemsDataSet.add(_.concat(activityItemsToAdd, backgroundItemsToAdd));

      // Update groups and items

      if (currentRoutesToUpdate.length) {
        const groupsToUpdate = this._mapRoutesToGroups(currentRoutesToUpdate, this.draftAnalysis);
        this.groupsDataSet.update(groupsToUpdate);
      }

      if (this.inspectedStopIds?.length) {
        this._setInspectedItemsByIds(this.inspectedStopIds);
      }

      if (this.isFirstFit) {
        this.fitTimeline();
        this.isFirstFit = false;
      }
    }

    // if (changes.selectedItemId && !changes.selectedItemId.isFirstChange()) {
    //   const currentSelectedId = changes.selectedItemId.currentValue;
    //   const previousSelectedId = changes.selectedItemId.previousValue;
    //
    //   const selectedTask = this._getTimelineActivityById(this.selectedItemId);
    //   if (selectedTask) {
    //     this.timeline.setSelection(selectedTask.id);
    //   }
    //   this._updateTimelineSelectedTassStyle(currentSelectedId, previousSelectedId);
    // }

    if (changes.selectedJobIds) {
      const previousSelectedActivities = angular.copy(this.selectedActivities || []);
      this.selectedActivities = this._getTimelineActivitiesByJobIds(this.selectedJobIds);
      if (!!this.selectedActivities.length) {
        this.timeline.setSelection(this.selectedActivities);
      }

      this._updateTimelineSelectedActivitesStyle(this.selectedActivities.map(a => a.id), previousSelectedActivities.map(a => a.id));
    }

    if (changes.from && !changes.from.isFirstChange() ||
      changes.to && !changes.to.isFirstChange()) {
      this.options.min = this.moment(this.from).subtract(1, 'hour');
      this.options.max = this.moment(this.to).add(1, 'hour');
      this.timeline.setOptions(this.options);
    }

    if (changes.isGroupedRoutes && !changes.isGroupedRoutes.isFirstChange()) {
      _.get(this.options, 'stack', undefined)
      this.options.stack = !this.isGroupedRoutes;
      this.timeline.setOptions(this.options);
    }

    if (changes.hiddenRouteIds && !changes.hiddenRouteIds.isFirstChange()) {
      const eyeButtons = document.getElementsByClassName("eye-button");
      _.forEach(eyeButtons, (b: any) => {
        const isEnabled = !_.includes(this.hiddenRouteIds, b.id);
        b.src = isEnabled ? this.iconsUrl.eyeOn : this.iconsUrl.eyeOff;
        b.enabled = isEnabled;
        // b.style.opacity = isEnabled ? '1' : '0.5';
      });
    }

    if (changes.inspectedStopIds && !changes.inspectedStopIds.isFirstChange()) {
      this._setInspectedItemsByIds(this.inspectedStopIds);
    }

    if (changes.doFit && !changes.doFit.isFirstChange()) {
      if (this.doFit) {
        this.fitTimeline();
      }
    }

  }


  // ******************************
  //        Public methods
  // ******************************

  onTimelineInit() {
    this.$timeout(0).then(() => {
      this.resizeService.resize();
    });
  }

  onChangeShowTooltips(showTooltips) {
    this.options.showTooltips = showTooltips;
    this.timeline.setOptions(this.options);
  }

  public _addRoutesToTimeline(routes) {

    // Make sure the routes doesnt exist in timeline before adding them.
    const currentRouteIdsInTimeline = this.groupsDataSet.getIds();
    routes = _.filter(routes, (r) => {
      return !_.includes(currentRouteIdsInTimeline, r.id);
    })

    const groups = this._mapRoutesToGroups(routes, this.draftAnalysis);
    this.groupsDataSet.add(_.sortBy(groups, ['resourceName', 'eta']));
  }

  public _addActivitiesToTimeline(routes) {
    const activityItems = this._mapRoutesToActivityItems(routes, this.draftAnalysis);
    const routeIds = _.map(routes, 'id');
    let reTripItems = [];
    if (this.draft?.settings?.planRetrips) {
      reTripItems = this._mapRoutesToReTripsItems(routes);
    }

    // // Remove RoutesRetripItems
    // const itemsToRemove = [];
    // this.itemsDataSet.forEach((item) => {
    //   if (item.isRetrip && _.includes(routeIds, item.routeId)) {
    //     retripItemIdsToRemove.push(item.id);
    //   }
    // })

    // if (retripItemIdsToRemove.length) {
    //   this.itemsDataSet.remove(retripItemIdsToRemove);
    // }

    const backgroundItems: any = this._mapRoutesToBackgroundItems(routes);
    const itemIdsToRemoveBeforeAdd = _.map(_.concat(activityItems, reTripItems, backgroundItems), 'id');

    const itemsToRemove = [];
    this.itemsDataSet.forEach((item) => {
      if (_.includes(itemIdsToRemoveBeforeAdd, item.id) || (item.isRetrip && _.includes(routeIds, item.routeId))) {
        itemsToRemove.push(item.id);
      }
    })

    if (itemsToRemove.length) {
      this.itemsDataSet.remove(itemsToRemove);
    }

    this.$timeout(0).then(() => {
      this.itemsDataSet.add(_.concat(activityItems, reTripItems, backgroundItems));
    });
  }

  public _mapRoutesToGroups(routes, analysis) {
    const routeDependencies = _.get(analysis, 'routeDependencies', {}),   // A MAP BY ID// A MAP BY ID
      routeWarnings = _.get(analysis, 'routeWarnings', {});
    return _.map(routes, (route, index) => {
      const routeWarningsRef = routeWarnings[route.id];
      const color = this._getRouteColor(route.id);
      const relatedRoutes = routeDependencies[route.id];
      return this._getGroupData(route, index, color, relatedRoutes, routeWarningsRef);
    });
  }

  public _mapRoutesToActivityItems(routes, analysis) {
    const routeDependencies = _.get(analysis, 'routeDependencies', {}),   // A MAP BY ID
      stopDependencies = _.get(analysis, 'stopDependencies', {}),     // A MAP BY ID
      stopWarnings = _.get(analysis, 'stopWarnings', {}); // A MAP BY ID
    return _.flatMap(routes, (route) => {
      const color = this._getRouteColor(route.id);
      return this._getItemsData(route, route.activities, color, routeDependencies, stopDependencies, stopWarnings);
    });
  }

  public _mapRoutesToReTripsItems(routes) {
    return _.flatMap(routes, (route) => {
      const color = this._getRouteColor(route.id);
      return this._getReTripItemsData(route, color);
    });
  }

  public _mapRoutesToBackgroundItems(routes) {
    // return _.flatMap(routes, (route) => {
    //   const color = this._getRouteColor(route.id);
    //   return this._mapRouteToBackgroundItem(route, color);
    // });
    let backgroundItems = [];
    routes.forEach((route) => {
      const color = this._getRouteColor(route.id);
      const items = this._mapRouteToBackgroundItem(route, color)
      backgroundItems.push(...items);
    })
    return backgroundItems;
  }

  public _mapRouteToBackgroundItem(route, color) {
    let backgroundItems = [];

    let currentPackagesOnCurrentLocation = [];

    route.activities.forEach((activity, index) => {
      if (!route.activities[index + 1]) {
        return;
      }

      if (activity.stopType === 'Pickup') {
        currentPackagesOnCurrentLocation.push(...activity.packages);
      }

      if (activity.stopType === 'Dropoff') {
        activity.packages.forEach(activityPackage => {
          const packageIndex = currentPackagesOnCurrentLocation.findIndex(currentPackage => activityPackage.id === currentPackage.id);
          if (packageIndex > -1) {
            currentPackagesOnCurrentLocation.splice(packageIndex, 1)
          }
        })
      }
      const backgroundItem: any = {
        id: route.id + activity.id,
        start: this.moment(activity.eta),
        end: this.moment(route.activities[index + 1].eta),
        group: route.id,
        type: 'background',
        style: 'background-color: ' + color,
        className: `route-background ${!currentPackagesOnCurrentLocation.length ? 'empty' : ''}`
      }

      backgroundItems.push(backgroundItem);
    })
    return backgroundItems;
    // return {
    //   id: route.id,
    //   start: this.moment(route.activities[0].eta),
    //   end: this.moment(route.activities[route.activities.length - 1].eta),
    //   group: route.id,
    //   type: 'background',
    //   style: 'background-color: ' + color
    // }
  }

  public onToggleSeeAll() {
    const isCurrentlyHidden = this.hiddenRouteIds.length === this.allRoutes.length;
    this.onToggleHiddenRoutes({routeIds: isCurrentlyHidden ? [] : _.map(this.allRoutes, 'id')});
  }

  public onCloseInspectMode() {
    this.onInspectedStopIdsChange({ids: []});
  }

  public fitTimeline() {
    // _onClicked().then(function() {
    //     timeline.fit();
    // });
    // timeline.fit();
    this.$timeout(200).then(() => {
      this.timeline.fit();
      this.onFit();
    });
  }

  onZoom(isZoomIn) {
    isZoomIn ? this.timeline.zoomIn(0.5) : this.timeline.zoomOut(0.5);
  }


  //////////////////////// PRIVATE METHODS ////////////////////////

  private _createEyeButton(id, isEnabled) {
    const eyeButton = this.$eyeIcon.cloneNode(true);
    eyeButton.src = isEnabled ? this.iconsUrl.eyeOn : this.iconsUrl.eyeOff;
    eyeButton.id = id;
    eyeButton.classList.add("cursor-pointer", "eye-button", "gray");
    eyeButton.enabled = isEnabled;
    if (id) {
      eyeButton.dataset.bzAction = 'toggle-route';
      eyeButton.dataset.bzId = String(id);
    }
    return eyeButton;
  }

  private _createInfoButton(routeId) {
    const infoButton = this.$infoIcon.cloneNode(true);
    infoButton.classList.add("gray", "cursor-pointer");
    if (routeId) {
      infoButton.dataset.bzAction = 'route-info';
      infoButton.dataset.bzId = String(routeId);
    }
    return infoButton;
  }


  private _getRelatedRoutesIndicationDiv(routeIds) {

    const MAX_COLOR_DIVS = 5;

    routeIds = _.uniq(routeIds);

    const container = document.createElement('div');
    container.classList.add("related-route-div");

    _.forEach(routeIds, (rid, i: number) => {
      if (i + 1 <= MAX_COLOR_DIVS) {
        const color = this._getRouteColor(rid);
        const colorDiv = document.createElement('div');

        colorDiv.classList.add("related-route-color-dot");
        colorDiv.style.backgroundColor = color;
        container.appendChild(colorDiv);
      }
    });

    if (routeIds.length > MAX_COLOR_DIVS) {
      const diff = routeIds.length - MAX_COLOR_DIVS;
      const extraCountSpan = document.createElement('span');
      extraCountSpan.textContent = '+' + diff.toString();
      container.appendChild(extraCountSpan);
    }

    return container;
  }

  private _getWarningDetails(warnings) {
    const mapByType = {};
    const warningList = [];
    _.forEach(warnings, (w) => {
      const warnRef = mapByType[w.type];
      mapByType[w.type] = warnRef ? (warnRef + 1) : 1
    });
    _.forOwn(mapByType, (value, key) => {
      warningList.push(value + ' ' + this.$filter('translate')(key));
      // string += value + ' ' + $filter('translate')(key) + ', '
    });
    return warningList;
  }

  private _getRouteColor(routeId) {
    const route = _.find(this.allRoutes, function (r) {
      return r.id === routeId;
    })
    return this.planningCommonService.getRouteColor(route);
  }

  private _getTranslatedAgentSkills(skills, isFirstLetterOnly) {
    return _.map(skills, (s) => {
      return this._getTranslatedSkill(s, isFirstLetterOnly)
    });
  }

  private _getTranslatedSkill(skill, isFirstLetterOnly) {
    const text = this.$filter('translate')('SKILLS.' + skill);
    return isFirstLetterOnly ? text.charAt(0) : text;
  }

  // ******************************
  //        Private methods
  // ******************************

  /**
   * Helper method to get the resource name for sorting purposes.
   * Used to group routes by resource in the timeline.
   */
  private _getResourceNameForSort(route): string {
    const resourceSource = _.get(route, 'resource.source');
    return resourceSource === 'AgentSchedule'
      ? _.get(route, 'resource.agentName', '---')
      : (_.get(route, 'resource.allocationName') || _.get(route, 'resource.vehicleName', '---'));
  }

  private _getGroupData(route, index, color, relatedRoutes, routeWarnings) {

    const firstActivity: any = _.head(route.activities);
    const lastActivity: any = _.last(route.activities);

    const resourceName = this._getResourceNameForSort(route);
    const firstActivityDepotName = _.get(this.depotsMap, firstActivity.depotId + '.name', '---');
    const lastActivityDepotName = _.get(this.depotsMap, lastActivity.depotId + '.name', '---');

    // // Sort all routes by resource name, sequenceInRouteGroup, and ETA to group routes with the same resource together
    // const sortedRoutes = _.sortBy(this.routes, [
    //   (r) => this._getResourceNameForSort(r),
    //   (r) => r.sequenceInRouteGroup ?? 0,
    //   (r) => _.get(_.head(r.activities), 'eta')
    // ]);
    //
    const routeIndex = _.findIndex(this.routes, (r: any) => {
      return r.id === route.id;
    })

    const maxVolume = route.resource?.capacity?.dimensions ?
      (route.resource.capacity.dimensions.height * route.resource.capacity.dimensions.width * route.resource.capacity.dimensions.length) : undefined;

    const isRouteRunning = this._getIsRouteRunning(route);

    return {
      id: route.id,
      order: routeIndex,
      locked: route.locked || isRouteRunning,
      running: isRouteRunning,
      color: color || 'black',
      status: isRouteRunning ? (route.actionProcess.isDispatching ? 'DISPATCHING' : 'OPTIMIZING') : route.status,
      resourceName: resourceName,
      totalIncome: _.get(route, 'totals.totalIncome'),
      minimumIncome: _.get(route, 'resource.routeIncomePreferences.minimumRouteIncome') || _.get(this.draft, 'settings.incomeSettings.minRouteIncome'),
      maximumIncome: _.get(route, 'resource.routeIncomePreferences.maximumRouteIncome') || _.get(this.draft, 'settings.incomeSettings.maxRouteIncome'),
      agentName: _.get(route, 'resource.agentName', '---'), // missing on resource data
      allocationSkills: _.get(route, 'resource.allocationSkills', []),
      agentSkills: this._getTranslatedAgentSkills(_.get(route, 'resource.allocationSkills', []), true), // missing on resource type VEHICLE data - talk to eliav
      vehicle: _.get(route, 'resource.vehicleName', '---'),
      load: this.$filter('bringozWeight')(route.totals.totalLoad, true),
      value: this.$filter('bringozPrice')(route.totals.value),
      cost: this.$filter('bringozPrice')(route.totals.cost),
      distance: this.$filter('bringozDistance')(route.totals.totalDistanceMeter),
      stops: route.totals.totalStopsCount || '---',
      jobs: route.totals.totalJobsCount || '---',
      weightPercentage: route.weightPercentage,
      volumePercentage: route.capacityPercentage,
      weight: _.round(_.get(route.totals, 'totalLoad'), 1),
      maxWeight: _.round(_.get(route, 'resource.capacity.weight'), 1) || this.$infinitySymbol,
      volume: _.round(_.get(route.totals, 'totalVolume'), 1),
      maxVolume: _.round(maxVolume, 1) || this.$infinitySymbol,
      pallets: _.round(_.get(route.totals, 'totalPallets'), 1) || 0,
      maxPallets: _.round(_.get(route, 'resource.capacity.numberOfPallets'), 1) || this.$infinitySymbol,
      packagesCount: _.get(route.totals, 'totalPackagesCount', '---'),
      maxPackagesCount: _.get(route, 'resource.capacity.numberOfPackages', this.$infinitySymbol),
      spots: _.round(_.get(route.totals, 'totalSpots'), 1) || 0,
      maxSpots: _.round(_.get(route, 'resource.capacity.numberOfSpots'), 1) || this.$infinitySymbol,
      alerts: routeWarnings || [],
      duration: this.$filter('translate')('Duration') + ': ' + this.$filter('bringozTimeConvert')(route.totals.totalTimeSec),
      timeWindow: this.$filter('timeWindow')({
        notBefore: _.get(firstActivity, 'eta'),
        notAfter: _.get(lastActivity, 'eta')
      }),
      eta: _.get(firstActivity, 'eta'),
      className: `group-row br-caption-2 ${(route.locked || isRouteRunning) ? 'locked' : ''}`,
      enabled: true, // For Eye icon (show or not in map)
      visible: true, // For filtering the displayed routes in table
      relatedRoutes: relatedRoutes || [],
      startDepot: firstActivityDepotName,
      endDepot: lastActivityDepotName
    };
  }

  private _getItemsData(route, activities, color, routeDependencies, stopDependencies, stopWarnings) {
    // var stopIndex = 0;

    const relatedRoutes = routeDependencies[route.id];

    return _.map(activities, (activity, index) => {
      const defaultServiceTime = 60000;
      const activityServiceTimeInMili = _.get(activity, 'serviceTime', 5) * defaultServiceTime;
      const activityEta = _.get(activity, 'eta');
      const activityEtd = _.get(activity, 'etd', activityEta + activityServiceTimeInMili);

      const activityPurpose = activity.stopType || 'Dropoff';
      const isStop = _.isEqual(activity.type, 'STOP');
      const isGroup = _.isEqual(activity.type, 'GROUP');
      const isPoint = (!isStop && !isGroup);

      const relatedStops = isStop ? stopDependencies[activity.stopId] : (isGroup ? _getStopDependenciesForGroup(stopDependencies) : []),
        warnings = isStop ? stopWarnings[activity.stopId] : (isGroup ? _getStopDependenciesForGroup(stopWarnings) : []);

      // if (isStop || isGroup) {
      //   stopIndex++;
      // }

      function _getStopDependenciesForGroup(map) {
        const stopActivityIds = _.map(activity.stopActivities, 'stopId');
        const allArrays = _.chain(map)
          .pickBy((value, key) => {
            return _.includes(stopActivityIds, key);
          })
          .toArray()
          .value();
        return _.spread(_.union)(allArrays);
      }

      const isRouteRunning = this._getIsRouteRunning(route);
      const className = `${activityPurpose} ${isPoint ? 'point' : (isGroup ? 'group' : 'stop')}`

      return {
        ref: activity,
        id: activity.id,
        start: this.moment(activityEta),
        end: this.moment(activityEtd || (activityEta + activityServiceTimeInMili)),
        group: route.id,
        routeId: route.id,
        accountName: activity.accountName,
        activityId: activity.id,
        stopId: activity.stopId,
        stopIds: _.get(activity, 'stopIds', []), // For Groups Only
        jobIds: activity.jobId ? [activity.jobId] : _.get(activity, 'jobIds', []),
        purpose: activityPurpose,
        activityType: activity.type,
        routeColor: color,
        routeStatus: route.status,
        relatedRoutes: relatedRoutes || [],
        relatedStops: relatedStops || [],
        warnings: warnings || [],
        point: (!isStop && !isGroup) ? 'point' : 'box',
        title: isPoint ? this._getStartEndTooltip(activity) :
          this._getStopTooltip(activity, relatedStops, warnings),
        content: isPoint ?
          this._getStartEndPointsContent(activity, color) :
          this._getStopContent(activity, relatedStops, warnings, color, this.draft?.settings?.planRetrips),
        style: isPoint ?
          'background-color: #7E7E7E !important; color: white;' :
          `background-color: white; border-color: ${color}; color: ${color};`,
        // style: 'background-color: ' + `${color}30` + '; color: white',
        className: className,
        editable: {
          add: false,                                                                // add new items by double tapping
          updateTime: !route.locked && !isRouteRunning,        // drag items horizontally
          updateGroup: route.status === 'DISPATCHED' || this.isActivityLocked(activity) ? false : (!route.locked && !isRouteRunning),      // drag items from one group to another
        }
      }
    });
  }

  private isActivityLocked(activity) {
    if (activity.jobId) {
      return !!this.jobsMap[activity.jobId]?.lockedRouteId;
    } else if (activity.jobIds?.length) {
      for (let id of activity.jobIds) {
        if (!!this.jobsMap[id]?.lockedRouteId) {
          return true;
        }
      }
      return false;
    }
  }

  private _getReTripItemsData(route, color) {
    const items = [];

    _.forEach(route.activities, (a, index: number) => {
      if (!!a.tripNumber && a.tripNumber > 1) {
        if ((!index) || ((route.activities[index - 1]?.tripNumber || 0) < a.tripNumber)) {
          const milisBefore = 30000;
          const activityEta = _.get(a, 'eta');

          items.push(
            {
              isRetrip: true,
              id: route.id + a.tripNumber,
              routeId: route.id,
              start: this.moment(activityEta - milisBefore),
              end: this.moment(activityEta - milisBefore),
              group: route.id,
              routeColor: color,
              style: `background-color: white; border-color: ${color}; color: ${color};`,
              className: 'trip',
              editable: false
            }
          )
        }
      }
    })

    return items;
  }


  private _getStartEndPointsContent(activity, routeColor) {
    const stopType = activity.type;
    const label = this.$filter('translate')(stopType === 'START' ? 'S' : 'E');
    return '<span class="br-body-2 font-weight-400 ' + label + '">' + label + '</span>'
      + '<div class="dot" style="background-color: #7E7E7E"></div>'
  }

  private _getStopContent(activity, relatedStops, warnings, color, includeRetrip?) {

    const stopType = activity.stopType || activity.type;
    const activityType = activity.type;
    const tripNumber = activity.tripNumber;
    const itemType = stopType || activityType;
    const isGroup = _.isEqual(activity.type, 'GROUP');

    let relationIcon;
    const relationDivs = document.createElement('div');
    if (relatedStops && relatedStops.length) {
      relationIcon = this.$linkIcon.cloneNode(true);
      relationIcon.classList.add('white');
      const routeIds = _.flatMap(relatedStops, function (r) {
        return r.routeIds;
      });

      relationDivs.appendChild(this._getRelatedRoutesIndicationDiv(routeIds));
    }

    const warningsDiv = document.createElement('div');
    let warnIcon;

    if (warnings && warnings.length) {
      warnIcon = this.$errorIcon.cloneNode(true);
      warnIcon.classList.add('white');
      const warningTypes = _.flatMap(warnings, (w) => {
        return this.$filter('translate')(w.type);
      });
      warningsDiv.classList.add('info-row');
      warningsDiv.appendChild(warnIcon);
      const span = document.createElement('span');
      _.forEach(warningTypes, function (w, i) {
        if (i + 1 < warningTypes.length) {
          w += ', '
        }
        span.textContent += w;
      })
      warningsDiv.appendChild(span);
    }

    let spanRow;
    if (!!activity?.tripNumber && includeRetrip) {
      spanRow = '<span class="trip-number-index">' + activity.tripNumber + '</span>'
    }

    return isGroup ?
      '<div ' + BRINGOZ_ID_GENERATOR_ATTRIBUTE_NAME + '="drag-route-task-timeline" class="item-body br-caption-1 font-weight-800" style="background-color: ' + color + 20 + '">'
      + '<span class="text">' + this.$filter('translate')(itemType.charAt(0)) + '(' + activity.stopActivities.length + ') ' + activity.indexInRoute + '</span>'
      + (spanRow ? spanRow : '')
      + '</div>'
      + (relationIcon ? relationIcon.outerHTML : '')
      + (warnIcon ? warnIcon.outerHTML : '') :
      '<div ' + BRINGOZ_ID_GENERATOR_ATTRIBUTE_NAME + '="drag-route-task-timeline" class="item-body br-caption-1 font-weight-800" style="background-color: ' + color + 20 + '">'
      + '<span class="text">' + this.$filter('translate')(itemType.charAt(0)) + ' ' + (activity.indexInRoute) + '</span>'
      + (spanRow ? spanRow : '')
      + '</div>'

    // return isGroup ? '<span class="br-caption-2">' + this.$filter('translate')(itemType.charAt(0)) + '(' + activity.stopActivities.length + ') ' + activity.indexInRoute + '</span>'
    //   + (relationIcon ? relationIcon.outerHTML : '')
    //   + (warnIcon ? warnIcon.outerHTML : '') :
    //   '<span class="br-caption-2">' + this.$filter('translate')(itemType.charAt(0)) + ' ' + (activity.indexInRoute) + '</span>'
    //   + (relationIcon ? relationIcon.outerHTML : '')
    //   + (warnIcon ? warnIcon.outerHTML : '');
  }

  private _getStartEndTooltip(activity) {
    const routeColor = this._getRouteColor(activity.routeId);
    const stopType = activity.type;
    const depotId = _.get(activity, 'depotId');
    const depotName = _.get(this.depotsMap, [depotId, 'name']);
    let tooltipTemplate = '<div class="header-container">'
      + '<span class="br-body-2 font-weight-600" style="color: ' + routeColor + '">' + this.$filter('translate')(stopType) + '</span>'
      + '</div>';

    if (depotName) {
      tooltipTemplate += '<div class="info-row">'
        + this.$depotIcon.outerHTML
        + '<span class="br-body-2 margin-left-5">' + escapeHtml(depotName) + '</span>'
        + '</div>';
    }

    tooltipTemplate += '<div class="info-row">'
      + this.$locationIcon.outerHTML
      + '<span class="br-body-2 margin-left-5">' + escapeHtml(this.$filter('bringozAddress')(activity.address)) + '</span>'
      + '</div>';

    return tooltipTemplate;
  }


  private _getStopTooltip(activity, relatedStops, warnings) {

    const routeColor = this._getRouteColor(activity.routeId);
    const serviceTime = activity.serviceTime;
    const depotId = _.get(activity, 'depotId');
    const originalTimeWindow = this.$filter('timeWindow')(activity);
    const activityType = activity.type;

    const defaultServiceTime = 60000;
    const activityServiceTimeInMili = _.get(activity, 'serviceTime', 5) * defaultServiceTime;
    const activityEta = _.get(activity, 'eta');
    const activityEtd = _.get(activity, 'etd', activityEta + activityServiceTimeInMili);

    const activityPurpose = activity.stopType || '---';
    const isStop = _.isEqual(activity.type, 'STOP');
    const isGroup = _.isEqual(activity.type, 'GROUP');
    const isPoint = (!isStop && !isGroup && !_.get(activity, 'serviceTime'));
    const stopTimeWindow = this.$filter('timeWindow')({notBefore: activityEta, notAfter: activityEtd});
    const barcodes = this.planningCommonService.getBarcodesString(activity);
    const activityPackageTotals = this.planningCommonService.getActivityPackageTotals(activity);
    const spotsTotal = this.$filter('orderSpots')(activity.packages);
    const relationDivs = document.createElement('div');
    let tripNumberRow = '';



    let relationIcon;
    if (relatedStops && relatedStops.length) {
      relationIcon = document.createElement('IMG');
      relationIcon.setAttribute("src", this.iconsUrl.relation);
      relationIcon.classList.add('bringoz-icon');
      const routeIds = _.flatMap(relatedStops, function (r) {
        return r.routeIds;
      });

      relationDivs.appendChild(this._getRelatedRoutesIndicationDiv(routeIds));
    }

    const warningsDiv = document.createElement('div');
    let warnIcon;

    if (warnings && warnings.length) {
      warnIcon = this.$menuIcon.cloneNode(true);

      const warningTypes = _.flatMap(warnings, (w) => {
        return this.$filter('translate')(w.type);
      });
      warningsDiv.classList.add('info-row');
      warningsDiv.appendChild(warnIcon);
      const span = document.createElement('span');
      _.forEach(warningTypes, function (w, i) {
        if (i + 1 < warningTypes.length) {
          w += ', '
        }
        span.textContent += w;
      })
      warningsDiv.appendChild(span);
    }

    if (!!activity?.tripNumber) {
      tripNumberRow = '<div class="info-row">'
        + this.$tripIcon.outerHTML
        + '<span class="br-body-2">' + activity.tripNumber + '</span>'
        + '</div>'
    }

    // const skillsDiv = document.createElement('div');
    // const skills = _.get(ctrl.jobsMap[activity.jobId], 'skills', []);
    //
    // if (skills && skills.length) {
    //   _.forEach(skills, function(s, i) {
    //     const skill = document.createElement('div');
    //     skill.classList.add('skill-tag');
    //
    //     const skillText = document.createElement('span');
    //     skillText.innerHTML = _getTranslatedSkill(s);
    //     skill.appendChild(skillText);
    //     skillsDiv.appendChild(skill);
    //   })
    // }

    const activityAddress = _.get(activity, 'stopActivities[0].address', activity.address);
    const activityAccount = _.get(activity, 'stopActivities[0].accountName', activity.accountName) || '---';
    const tooltipHeader = (isGroup ? this.$filter('translate')('Multi') + ' ' : '') + activityPurpose;

    return '<div class="header-container">'
      + '<span class="br-body-2 font-weight-600" style="color: ' + routeColor + '">' + tooltipHeader + '</span>'
      + (relationIcon ? relationIcon.outerHTML : '')
      + relationDivs.outerHTML
      + '</div>'
      // + '<div class="info-row">'
      // + this.$locationIcon.outerHTML
      // + '<span class="br-body-2 margin-left-5">' + this.$filter('bringozAddress')(activityAddress) + '</span>'
      // + '</div>'
      + '<div class="info-row">'
      + this.$accountIcon.outerHTML
      + '<span class="br-body-2 margin-left-5">' + escapeHtml(activityAccount) + '</span>'
      + '</div>'
      // + '<div class="info-row">'
      // + this.$depotIcon.outerHTML
      // + '<span class="br-body-2 margin-left-5">' + _.get(this.depotsMap, depotId + '.name', '---') + '</span>'
      // + '</div>'
      // + '<div class="info-row">'
      // + $skillsIcon.outerHTML
      // + skillsDiv.outerHTML
      // + '</div>'
      + '<div class="info-row">'
      + this.$originalTimeWindowIcon.outerHTML
      // + '<span class="br-body-2 margin-left-5">' + this.$filter('bringozDate')(activity.notBefore) + '</span>'
      + '<span class="br-body-2">' + originalTimeWindow + '</span>'
      + '</div>'
      + '<div class="info-row">'
      + this.$timeWindowIcon.outerHTML
      + '<span class="br-body-2 margin-right-10">' + stopTimeWindow + '</span>'
      // + this.$serviceTimeIcon.outerHTML
      // + '<span class="br-body-2 margin-left-5">' + this.$filter('bringozTimeConvert')(serviceTime, false, true) + '</span>'
      + '</div>'
      + tripNumberRow
      // + warningsDiv.outerHTML
      + '<div class="info-row margin-right-5">'
      + this.$packageIcon.outerHTML
      + '<span class="br-body-2 margin-right-5">' + _.get(activityPackageTotals, 'packages', '---') + '</span>'
      + this.$weightIcon.outerHTML
      + '<span class="br-body-2 margin-right-5">' + _.get(activityPackageTotals, 'weight', '---') + '</span>'
      + this.$volumeIcon.outerHTML
      + '<span class="br-body-2 margin-right-5">' + _.get(activityPackageTotals, 'volume', '---') + '</span>'
      + this.$palletsIcon.outerHTML
      + '<span class="br-body-2 margin-right-5">' + _.get(activityPackageTotals, 'pallets', '---') + '</span>'
      + this.$spotsIcon.outerHTML
      + '<span class="br-body-2">' + spotsTotal + '</span>'
      + '</div>'
    // + '<div class="info-row">'
    // + this.$barcodeIcon.outerHTML
    // + '<span class="br-body-2 margin-left-5">' + barcodes + '</span>'
    // + '</div>'
  }


  private _onClicked() {
    const deferred = this.$q.defer();
    deferred.resolve();
    return deferred.promise;
  }

  private _getTimelineActivityById(id) {

    if (!id) {
      return undefined;
    }

    const selectedItem = this.itemsDataSet.get({
      filter: (item) => {
        return item.id === id || item.activityId === id;
      }
    });
    return this.itemsDataSet.get(selectedItem[0] ? selectedItem[0].id : undefined)
  }

  private _getTimelineActivitiesByJobIds(jobIds) {

    let activities = [];
    if (!jobIds) {
      return [];
    }

    this.itemsDataSet?.forEach((item) => {
      if (item.jobIds?.length && item.jobIds.every(jobId => jobIds.includes(jobId))) {
        activities.push(item);
      }
    });
    return activities;
  }

  private _setGroupVisibilityByIds(ids) {

    const updatedGroups = [];

    this.groupsDataSet.forEach((group) => {
      group.visible = ids ? _.includes(ids, group.id) : true;
      // group.visible = (ids && ids.length) ?_.includes(ids, group.id) : true;
      updatedGroups.push(group);
    });

    this.timeline.setGroups(updatedGroups);
    this.fitTimeline();
  }

  private _getSpotsTotal(packages) {
    return this.$filter('orderSpots')(packages);
  }

  private _setInspectedItemsByIds(ids) {

    if (!ids) {
      ids = [];
    }

    const updatedItems = [];

    this.itemsDataSet.forEach((item) => {
      const isBackground = item.type === 'background';
      const isPoint = item.point === 'point';
      const isEnabled = !ids.length || (_.includes(ids, item.stopId) || _.intersection(ids, _.get(item, 'stopIds', [])).length > 0);
      // item.className = isPoint ? 'point' : (isBackground ? '' : 'stop');


      if (isEnabled) {
        item.className = item.className.replace("disabled", "");
      } else {
        item.className += ' disabled';
      }

      // const style = 'background-color: ' + item.routeColor + '!important;';
      // style += !ids.length || (_.includes(ids, item.stopId) || _.intersection(ids, _.get(item, 'stopIds', [])).length > 0) ? 'opacity: 1' : 'opacity: 0.3';
      // item.style = style;
      updatedItems.push(item);
    });

    this.itemsDataSet.update(updatedItems);

    // timeline.setItems(updatedItems);
  }

  private _canItemMove(item) {

    if (item.activityType === 'GROUP' && item.stopIds.length < 1) {
      return false;
    }

    if (item.activityType !== 'GROUP' && !item.stopId) {
      return false;
    }

    const orderedItems = _.filter(this.timeline.components[3].groups[item.group].orderedItems.byStart, (orderedItem) => {
      return !!orderedItem.data.activityType;
    });

    const itemPurpose = item.purpose;
    const itemIndex = _.findIndex(orderedItems, (orderedItem: any) => {
      return orderedItem.data.activityId === item.activityId;
    });

    const movedActivityOriginalRoute = _.find(this.routes, (r) => {
      const ids = _.map(r.activities, 'id');
      return _.includes(ids, item.id);
    })
    const activityOriginalIndex = _.findIndex(movedActivityOriginalRoute.activities, (a: any) => {
      return a.id === item.id;
    })

    if (_.isEqual(movedActivityOriginalRoute.id, item.group) &&
      _.isEqual(activityOriginalIndex, itemIndex)) {
      return false;
    }

    const parallelIndex = _.findIndex(orderedItems, (task: TaskModel) => {
      return (task.id !== item.id) && !!_.intersection(_.get(task, 'data.jobIds', []), _.get(item, 'jobIds', [])).length;
    });
    if (parallelIndex < 0) {
      return true;
    } else {
      return itemPurpose === 'Pickup' ? (itemIndex < parallelIndex) : (parallelIndex < itemIndex);
    }
  }

  private _confirmSkillMismatch(jobIds: string[], route: any): IPromise<boolean> {
    const warnings = route ? this.planningDialogService.getJobsSkillMismatchWarnings(_.compact(_.map(jobIds, (id) => this.jobsMap[id])), route) : [];

    if (!warnings.length) {
      return this.$q.resolve(false);
    }

    return this.planningDialogService.openJobAssignWarnings(warnings, undefined).then(() => true);
  }

  private _createBlockButton(id, locked, running) {
    const blockButton = this.$lockIcon.cloneNode(true);
    (blockButton as HTMLElement).setAttribute(BRINGOZ_ID_GENERATOR_ATTRIBUTE_NAME, "lock-route-timeline");
    blockButton.src = running ? this.iconsUrl.loader : (locked ? this.iconsUrl.locked : this.iconsUrl.unlocked);

    blockButton.id = id;
    blockButton.classList.add("md-icon-button", "block-button", "cursor-pointer", "margin-left-5");
    blockButton.locked = locked;
    blockButton.running = running;
    // Skip wiring the click action while a lock/unlock request is in flight —
    // matches the original `if (!running) addEventListener(...)` guard.
    if (!running && id) {
      blockButton.dataset.bzAction = 'lock-route';
      blockButton.dataset.bzId = String(id);
    }
    return blockButton;
  }

  private _initTimelineEventListeners() {

    const visLeft = document.getElementsByClassName('vis-left')[0];
    const labelSetDiv = document.getElementsByClassName('vis-labelset')[0];
    // const resizerWidth = parseInt($(visLeft).css('borderRightWidth'));
    let visLeftClientReact;
    let mouseDown = false;

    /////////////////////
    // Timeline Events //
    /////////////////////

    // Hover
    // this.timeline.on('mouseOver', (props) => {
    //   if (props.item) {
    //     this._onClicked().then(() => {
    //
    //       this.onActivityHover({id: props.item, $event: props.event});
    //     });
    //   }
    // });

    // DoubleClick Event
    this.timeline.on('doubleClick', (properties) => {
      if (!!_.get(properties, 'item')) {
        this._onClicked().then(() => {
          this.onZoomActivity({id: properties.item});
        });
      }
    });

    // On Item Click
    this.timeline.on('select', (properties) => {
      this._onClicked().then(() => {
        const selectedActivity = this._getTimelineActivityById(properties.items[0]);
        // this.onActivitySelection({jobIds: _.get(selectedActivity, 'jobIds')});

        if (selectedActivity && this.inspectedStopIds && this.inspectedStopIds.length) {
          const activityType = selectedActivity.activityType;
          const stopIds = activityType === 'STOP' ?
            [_.get(selectedActivity, 'stopId')] :
            _.get(selectedActivity, 'stopIds', []);
          const inspectedStopIds = _.map(selectedActivity.relatedStops, 'id').concat(stopIds);
          this.onInspectedStopIdsChange({ids: inspectedStopIds});
        }

        // properties.event.preventDefault();
      });
    });

    // On Timeline Click
    // timeline.on('click', function (properties) {
    //     _onClicked().then(function() {
    //         if (ctrl.inspectedStopIds && ctrl.inspectedStopIds.length && !properties.item) {
    //             ctrl.onInspectedStopIdsChange({ids: []});
    //         }
    //     });
    // });

    // Right Click
    this.timeline.on('contextmenu', (props) => {
      if (props.item) {
        const selectedActivity = this._getTimelineActivityById(props.item);
        if (selectedActivity && this.canEdit) {
          const activityType = selectedActivity.activityType;
          if (activityType === 'STOP' || activityType === 'GROUP') {

            const stopIds = activityType === 'STOP' ?
              [_.get(selectedActivity, 'stopId')] :
              _.get(selectedActivity, 'stopIds', []);

            this._onClicked().then(() => {
              this.onActivityRightClick({
                routeId: _.get(selectedActivity, 'routeId'),
                jobIds: selectedActivity.jobIds,
                stopIds: stopIds,
                relations: selectedActivity.relatedStops,
                $event: props.event
              })
            });
          }
        }
        // if (selectedActivity && ctrl.canEdit &&
        //     (selectedActivity.activityType === 'STOP' || selectedActivity.activityType === 'GROUP')) {
        //     _onClicked().then(function() {
        //         var stopIds =
        //         ctrl.onActivityRightClick({
        //             routeId: _.get(selectedActivity, 'routeId'),
        //             jobId:  _.get(selectedActivity, 'jobId'),
        //             stopId: _.get(selectedActivity, 'stopId'),
        //             stopIds: _.get(selectedActivity, 'stopIds'),
        //             hasRelations: selectedActivity.relatedStops.length > 0,
        //             $event: props.event
        //         })
        //     });
        // }
      }
      props.event.preventDefault();
    });

    // // Mouse Down
    // timeline.on('mouseDown', function (props) {
    //   visLeftClientReact = visLeft.getBoundingClientRect();
    //   var resizerFrom = visLeftClientReact.x + visLeftClientReact.width - resizerWidth;
    //   var resizerTo = visLeftClientReact.x + visLeftClientReact.width;
    //
    //   if (props.event.pageX >= resizerFrom && props.event.pageX <= resizerTo) {
    //     mouseDown = true;
    //   }
    // });
    //
    // // Mouse Move
    // timeline.on('mouseMove', function (props) {
    //   if (mouseDown) {
    //     var px = (props.event.pageX - visLeftClientReact.x);
    //     visLeft.style.width = px + 'px';
    //     tableHeaderDivRef.style.width = (px - resizerWidth) + 'px';
    //     timeline.redraw();
    //   }
    // });
    //
    // // Mouse Up
    // timeline.on('mouseUp', function (props) {
    //   mouseDown = false;
    // });
    //
    // ///////////////////
    // // Custom Events //
    // ///////////////////
    //
    // // Sync Scroll - Table Header & Table Body
    // labelSetDiv.addEventListener("scroll", function (e) {
    //   tableHeaderDivRef.scrollLeft = labelSetDiv.scrollLeft;
    // }, {passive: true});
  }

  private _updateTimelineSelectedTassStyle(currentSelectedId, previousSelectedId) {
    const itemsToUpdate = [];

    this.itemsDataSet.forEach((item) => {
      if (currentSelectedId === _.get(item, 'id')) {
        item.style = `background-color: ${item.routeColor}; border-color: ${item.routeColor}; color: white;`;
        itemsToUpdate.push(item);
      } else if (previousSelectedId === _.get(item, 'id')) {
        item.style = `background-color: white; border-color: ${item.routeColor}; color: ${item.routeColor};`;
        itemsToUpdate.push(item);
      }
    });
    this.itemsDataSet.update(itemsToUpdate);
  }

  private _updateTimelineSelectedActivitesStyle(currentSelectedIds, previousSelectedIds) {
    const itemsToUpdate = [];

    if (!this.itemsDataSet) {
      return;
    }

    this.itemsDataSet.forEach((item) => {
      if (currentSelectedIds?.includes(_.get(item, 'id'))) {
        item.style = `background-color: ${item.routeColor}; border-color: ${item.routeColor}; color: white;`;
        itemsToUpdate.push(item);
      } else if (previousSelectedIds?.includes(_.get(item, 'id'))) {
        item.style = `background-color: white; border-color: ${item.routeColor}; color: ${item.routeColor};`;
        itemsToUpdate.push(item);
      }
    });
    this.itemsDataSet.update(itemsToUpdate);
  }

  private _getIsRouteRunning(route) {
    return route?.actionProcess?.running && (new Date().getTime() < route?.actionProcess?.expirationDate);

  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningRoutesTimeline', {
    bindings: {
      from: '<',
      to: '<',
      allRoutes: '<',
      depotsMap: '<',
      mainRoutes: '<',
      routes: '<',
      jobs: '<?',
      queryString: '<?',
      draftAnalysis: '<?',
      draft: '<',
      selectedItemId: '<',
      selectedJobIds: '<?',
      canEdit: '<',
      displayPrice: '<',
      hiddenRouteIds: '<?',
      hideLockedRoutes: '<?',
      inspectedStopIds: '<',
      isGroupedRoutes: '<?',
      visibleResourceAllocationSkills: '<?',
      isValidateRouteVehicles: '<?',
      offset: '<?',
      limit: '<?',
      doFit: '<?',
      onFit: '&',
      onAddStopsToRoute: '&',
      onToggleRoute: '&',
      onRouteInfoClick: '&',
      onToggleHiddenRoutes: '&',
      onRoutesChange: '&',
      onLockRouteChange: '&',
      onInspectedStopIdsChange: '&',
      onZoomActivity: '&',
      onActivitySelection: '&',
      onActivityHover: '&',
      onActivityRightClick: '&',
      onMoveItem: '&',
      onRecalcRoute: '&',
      onDeleteRoute: '&',
      onDispatchRoute: '&',
      onChangeRouteResource: '&',
      onToggleHideLockedRoutes: '&',
      onQueryChange: '&',
      onFiltersChange: '&',
      onPaginationBrowse: '&',
      onPaginationChange: '&'
    },
    template: require('./planning-routes-timeline.html').default,
    controller: PlanningRoutesTimelineCtrl
  });
